declare global {
  interface Window {
    ReactNativeWebView: {
      postMessage: (message: string) => void;
    };
  }
}

const target = navigator.userAgent.includes('Android') ? document : window;

const RnEventHandler = {
  addMessageListener(callback?: any) {
    target.addEventListener('message', callback);
  },
  removeMessageListener(callback?: any) {
    target.removeEventListener('message', callback);
  },

  query(type: any, otherValues?: any) {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({ type, ...otherValues }),
      );
    }
  },

  updateNewCookieAtReactNative(cookie: string) {
    // 최신 쿠키를 RN으로 보내주어 RN에서도 쿠키를 최신으로 관리한다.
    try {
      this.query('cookie', { content: cookie });
    } catch (error) {
      console.error(
        'exception occurred while updating native app cookie.',
        error,
      );
    }
  },
};

export default RnEventHandler;
